import { CHECKOUT_URL } from './checkout'

export type BibleAsset =
  | 'bible'
  | 'console'
  | 'action'
  | 'hooks'
  | 'rights'
  | 'skool'

export interface BibleConfig {
  /** URL del checkout real. Vacío = los botones solo bajan a la oferta. */
  checkoutUrl: string
  /** MP4 público. Preferido si alojas el video directamente. */
  vslMp4Url: string
  /** Alternativa: URL embed HTTPS de Vimeo, YouTube o tu proveedor. */
  vslEmbedUrl: string
  /** Miniatura opcional para el MP4. */
  vslPosterUrl: string
  supportUrl: string
  privacyUrl: string
  termsUrl: string
  images: Record<BibleAsset, string>
}

export const bibleConfig: BibleConfig = {
  checkoutUrl: CHECKOUT_URL,
  vslMp4Url: '',
  vslEmbedUrl: 'https://embed.fliki.ai/embed/6aadcb5595c8e0e6adfaa7b5',
  vslPosterUrl: '',
  supportUrl: '',
  privacyUrl: '',
  termsUrl: '',
  images: {
    bible:
      'https://cdn.magicpatterns.com/uploads/aQrEqRjMdYQhRSjtcsxmtn/Visual_bible.png',
    console:
      'https://cdn.magicpatterns.com/uploads/hMYjwLrGNdCW4ryk77ssVK/BONO-1.png',
    action:
      'https://cdn.magicpatterns.com/uploads/ppfTjuJJQaDUg9D3ATjS7X/BONO-2.png',
    hooks:
      'https://cdn.magicpatterns.com/uploads/iGdtqaugGZLtvpExwF5Uxf/BONO-3.png',
    rights:
      'https://cdn.magicpatterns.com/uploads/nPfh4h89ghHBc7Rtk7ETJE/BONO-4.png',
    skool:
      'https://cdn.magicpatterns.com/uploads/5gCrrqdWMNZ7ZkjKuoaKZk/BONO-5.png'
  }
}
